import React, { Component } from 'react';

class IconSidebarItemDataCustomer extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="23"
                fill="none"
                viewBox="0 0 25 23"
            >
                <path
                    fill={this.props.isActive ? "#26A" : "#424242"}
                    d="M21.767 4H2.242A.239.239 0 002 4.24v13.53c0 .134.107.24.242.24h19.525a.239.239 0 00.243-.24V4.24C22 4.104 21.893 4 21.767 4zM3.63 16.402V5.608h16.76v10.794H3.63z"
                ></path>
                <path
                    fill={this.props.isActive ? "#26A" : "#424242"}
                    d="M10.826 11.407a3.086 3.086 0 00.844-2.029 3.047 3.047 0 00-.902-2.23c-1.154-1.129-3.007-1.205-4.22-.162a3.11 3.11 0 00-1.066 2.296c-.01.785.281 1.531.844 2.134a4.226 4.226 0 00-1.533 1.637c-.378.717-.523 1.53-.456 2.469.01.124.117.22.243.22h8.002a.242.242 0 00.242-.22c.097-1.79-.572-3.168-1.998-4.115zm-2.24.966c1.329.01 2.22.967 2.463 1.78H6.083a2.591 2.591 0 012.483-1.78h.02zm-.02-4.526h.01c.795.01 1.474.68 1.474 1.464 0 .383-.155.746-.446 1.034-.29.277-.65.43-1.038.42-.795-.009-1.474-.67-1.474-1.454 0-.383.155-.746.446-1.033a1.45 1.45 0 011.028-.431zM14.29 13.493h4.616a.794.794 0 00.796-.785.794.794 0 00-.796-.785H14.29a.794.794 0 00-.796.785c0 .43.359.785.796.785zM18.916 14.163H14.29a.794.794 0 00-.795.784c0 .43.359.785.796.785h4.626a.794.794 0 00.795-.785c.01-.43-.349-.784-.795-.784zM14.298 8.967h2.328a.796.796 0 00.796-.795.794.794 0 00-.796-.784h-2.328a.798.798 0 00-.795.804c0 .42.359.775.795.775zM18.916 8.976a.796.796 0 00.795-.794.796.796 0 00-1.59.01c0 .43.358.784.795.784z"
                ></path>
            </svg>
        );
    }
}

export default IconSidebarItemDataCustomer;